import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const zonaGT = "America/Guatemala";

export const formatearFechaChat = (fechaUtc) => {
  return dayjs.utc(fechaUtc).tz(zonaGT).format("DD/MM/YYYY - hh:mm A");
};

export const formatearTiempoTranscurrido = (fecha) => {
  const ahora = new Date();
  const pasada = new Date(fecha);
  const minutos = Math.floor((ahora - pasada) / 60000);
  if (minutos < 1) return "Ahora";
  if (minutos < 60) return `${minutos}m`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `${horas}h`;
  if (horas < 48) return "Ayer";
  return pasada.toLocaleDateString("es-GT");
};
